import { useContext, useMemo } from 'react'

import { useSelector } from 'react-redux'

import { InternshipStates, InternshipStatesString } from '../../../utils/constants'
import { GlobalContext } from '../../../Providers/GlobalProvider'
import { selectUser } from '../../../reducers/UserReducer'
import { isInstitutionMaccsUser, isPresiMaster, isSchoolMaccsUser } from '../../../utils/roles'
import StatesSelector from '../../../Components/shared/Selectors/StatesSelector/StatesSelector'

const {
  ACCEPTED, AUTO_ACCEPTED, ACCEPTED_UNMANAGED, CANCELED, CREATED,
  PENDING, PENDING_NO_SECTOR, PENDING_STUDENT_DATA_MISSING, PRE_ACCEPTED, REFUSED,
  SCHEDULE_ADDED, SCHEDULE_TO_VALIDATE, SCHEDULE_VALIDATED
} = InternshipStates
const ACCEPTED_STATES = [
  ACCEPTED, SCHEDULE_ADDED, SCHEDULE_VALIDATED, SCHEDULE_TO_VALIDATE,
  ACCEPTED_UNMANAGED, AUTO_ACCEPTED
]

const MaccsStatesSelector = ({ disabled, internship, onChange }) => {
  const { isReadOnly } = useContext(GlobalContext)

  const user = useSelector(selectUser)

  const parameters = useMemo(() => {
    const parameters = {
      disabled: false,
      states: [{ title: 'internship_states.' + InternshipStatesString[internship.state].toLowerCase(), state: internship.state }]
    }

    if (internship.state === SCHEDULE_VALIDATED) {
      parameters.disabled = true
    } else if (internship.state === PRE_ACCEPTED) {
      parameters.disabled = isPresiMaster(user)
      parameters.states.push({ title: 'Create', state: CREATED })

      if (isSchoolMaccsUser(user)) {
        parameters.disabled = isPresiMaster(user)
      } else {
        parameters.states.push({ title: 'Refuse', state: REFUSED })
      }
    } else if (internship.state === CANCELED) {
      parameters.states.push({ title: 'Put on hold', state: PENDING })
    } else if (internship.state === REFUSED) {
      parameters.states.push({ title: 'Put on hold', state: PENDING })

      if (isSchoolMaccsUser(user)) {
        parameters.states.push({ title: 'Cancel', state: CANCELED })
      } else {
        parameters.states.push({ title: 'Accept', state: ACCEPTED })
      }
    } else if ([PENDING, PENDING_NO_SECTOR, PENDING_STUDENT_DATA_MISSING, CREATED].includes(internship.state)) {
      parameters.disabled = isInstitutionMaccsUser(user) && [PENDING_NO_SECTOR, CREATED].includes(internship.state)

      if (isSchoolMaccsUser(user)) {
        parameters.states.push({ title: 'Cancel', state: CANCELED })
      } else {
        parameters.states.push({ title: 'Accept', state: REFUSED })

        if (internship.state === PENDING) {
          parameters.states.push({ title: 'Accept', state: ACCEPTED })
        }
      }
    } else if (ACCEPTED_STATES.includes(internship.state)) {
      parameters.disabled = isSchoolMaccsUser(user) && internship.state !== ACCEPTED_UNMANAGED
      parameters.states.push({ title: 'Put on hold', state: PENDING })

      if (isSchoolMaccsUser(user)) {
        parameters.states.push({ title: 'Cancel', state: CANCELED })
      } else {
        parameters.states.push({ title: 'Accept', state: REFUSED })
      }
    }

    return parameters
  }, [user, internship])

  return (
    <StatesSelector
      disabled={disabled || isReadOnly || parameters.disabled}
      internship={internship}
      states={parameters.states}
      onChange={onChange}
      showLabel={false}
    />
  )
}

export default MaccsStatesSelector
